import React, { useEffect, useState } from "react"
import {
    AspectRatio,
    ImageFileId,
} from "../../ui/ot"
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../ui/carousel"
import BookCoverManager from "./book_cover_manager"

const BookImages = ({
    bookImageData = [],
    biblionumber,
    title,
    isbn,
    showNavigation = true,
    autoPlay = false,
    autoPlayInterval = 3000,
    onChanged = () => { },
}) => {
    const [api, setApi] = useState()
    const [current, setCurrent] = useState(0)
    const [displayImageData, setDisplayImageData] = useState(bookImageData)

    useEffect(() => {
        setDisplayImageData(bookImageData)
        setCurrent(0)
    }, [bookImageData])

    const setCarouselApi = (carouselApi) => {
        setApi(carouselApi)
    }

    useEffect(() => {
        if (!api) return undefined

        const onSelect = () => setCurrent(api.selectedScrollSnap())
        onSelect()
        api.on("select", onSelect)

        return () => api.off("select", onSelect)
    }, [api])

    useEffect(() => {
        if (!api || !autoPlay || displayImageData.length <= 1) return undefined

        const timer = setInterval(() => api.scrollNext(), autoPlayInterval)

        return () => clearInterval(timer)
    }, [api, autoPlay, autoPlayInterval, displayImageData.length])

    return (
        <Carousel
            setApi={setCarouselApi}
            className="w-full"
            opts={{
                align: "start",
                loop: true,
            }}
        >
            <CarouselContent>
                {displayImageData.map((book, index) => (
                    <CarouselItem key={book?.file_id || book?.src || index}>
                        <AspectRatio ratio={3 / 4} className="bg-muted relative">
                            {book?.file_id ? (
                                <ImageFileId
                                    file_id={book.file_id}
                                    className="w-full rounded-md object-cover"
                                />
                            ) : (
                                <>
                                    <ImageFileId
                                        src={book?.src}
                                        className="w-full rounded-md object-cover"
                                    />
                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: 8,
                                            left: 8,
                                            background: "rgba(0,0,0,0.6)",
                                            color: "#fff",
                                            padding: "2px 8px",
                                            borderRadius: "4px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        由網路開放API抓取
                                    </div>
                                </>
                            )}
                        </AspectRatio>
                    </CarouselItem>
                ))}
            </CarouselContent>
            {showNavigation && (
                <div className="flex items-center justify-center gap-2 mt-4">
                    <CarouselPrevious className="static transform-none" />
                    <div className="text-sm">
                        {current + 1} / {displayImageData.length}
                    </div>
                    <CarouselNext className="static transform-none" />
                </div>
            )}
            <div className="mt-2">
                <BookCoverManager
                    biblionumber={biblionumber}
                    title={title}
                    isbn={isbn}
                    initialFileIds={displayImageData.filter((image) => image?.file_id).map((image) => image.file_id)}
                    buttonBlock
                    onChanged={(result) => {
                        const nextImages = result.fileIds.length > 0
                            ? result.fileIds.map((file_id) => ({ file_id }))
                            : [{ src: `https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=${isbn || ""}` }]
                        setDisplayImageData(nextImages)
                        setCurrent(0)
                        onChanged(result)
                    }}
                />
            </div>
        </Carousel>
    )
}

export default BookImages
